import { render, staticRenderFns } from "./Rights.vue?vue&type=template&id=9c99a4ee&scoped=true&"
import script from "./Rights.vue?vue&type=script&lang=js&"
export * from "./Rights.vue?vue&type=script&lang=js&"
import style0 from "./Rights.vue?vue&type=style&index=0&id=9c99a4ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c99a4ee",
  null
  
)

export default component.exports